/* eslint-disable max-len */

import { uniqBy } from 'lodash';
import api from '@/services/api';
import { updateMarket, updateMarketContracts } from '@/utils/notifications';

const DEFAULT_SEARCH = {
  data: [],
  page: 0,
  totalCount: 0,
  canLoadMore: true,
};

export default {
  namespaced: true,
  state: {
    searchBarVisible: false,
    hasSearched: false,
    searchQuery: '',
    searchResults: Object.create(DEFAULT_SEARCH),
  },
  mutations: {
    toggleSearchBar(state) {
      state.searchBarVisible = !state.searchBarVisible;
    },
    closeSearchBar(state) {
      state.searchBarVisible = false;
    },
    resetSearchResults(state) {
      state.searchResults = Object.create(DEFAULT_SEARCH);
    },
    setSearchResults(state, payload) {
      const sourceData = [...state.searchResults.data];
      const data = uniqBy(sourceData.concat(payload.data.markets || []), 'marketId');
      const page = payload.data.page;
      const totalCount = payload.data.totalMarkets;
      const canLoadMore = totalCount > data.length;

      state.searchResults = {
        ...state.searchResults,
        data,
        page,
        totalCount,
        canLoadMore,
      };
    },
    setHasSearched(state, flag) {
      state.hasSearched = flag;
    },
    setSearchQuery(state, query) {
      state.searchQuery = query;
    },
    updateMarketFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = {
          ...state.searchResults,
          data: state.searchResults.data.map((market) => updateMarket(market, data)),
        };
      }
    },
    updateContractFromNotification(state, data) {
      if (state.searchResults.data) {
        state.searchResults = {
          ...state.searchResults,
          data: state.searchResults.data.map((market) => updateMarketContracts(market, data)),
        };
      }
    },
  },
  actions: {
    toggleSearchBar({ commit }) {
      commit('toggleSearchBar');
    },
    closeSearchBar({ commit }) {
      commit('closeSearchBar');
    },
    getSearch({ state, commit }, query) {
      if (state.searchResults.canLoadMore) {
        const page = state.searchResults.page + 1;
        return api.browse.getSearch(query, page).then((response) => {
          commit('setHasSearched', true);
          commit('setSearchResults', {
            page,
            data: response.data,
          });
          return response.data;
        });
      }
      return Promise.resolve({ TotalMarkets: 0 });
    },
    resetSearchResults({ commit }, query) {
      commit('resetSearchResults');
      commit('setSearchQuery', query);
      if (!query) {
        commit('setHasSearched', false);
      }
    },
    updateMarketFromNotification({ commit }, payload) {
      commit('updateMarketFromNotification', payload);
    },
    updateContractFromNotification({ commit }, payload) {
      commit('updateContractFromNotification', payload);
    },
  },
};
